import React, { ReactElement } from 'react';
import { AuthContext } from 'auth';
import { consumeAuthRedirect } from 'auth/hooks';
import { Redirect } from 'react-router-dom';

export function AuthContainer(): ReactElement {
  const authContext = React.useContext(AuthContext);
  const isAuthenticated = authContext?.authState?.getIsAuthenticated();

  // If we got redirected back from FusionAuth, send the user to their last
  // requested page. Consuming the stored path erases it, so it is captured
  // once in the state initializer and stays stable for this mount.
  const [redirectedFrom] = React.useState(() =>
    isAuthenticated ? consumeAuthRedirect() : null,
  );

  if (redirectedFrom != null && redirectedFrom !== 'null') {
    return <Redirect push to={redirectedFrom} />;
  }

  return <Redirect push to="/" />;
}
